import React, { useState, useRef, useEffect } from "react";
import Chevron from "../chevron/Chevron";
import "./accordion.scss";
import RevenueDistribution from "../attributes/revenue-distribution/RevenueDistribution";
import Orders from "../attributes/orders/Orders";
import BarChart from "../attributes/bar-chart/BarChart";
//import Customers from "../attributes/customers/Customers";
import Credit from '../attributes/credit/Credit'
import { Footer, Header } from "../attributes/bar-chart-footer/BarChartFooter";
import ListItemWrapper from "../listItem/listItemWrapper";
import AccountReceivables from "../attributes/accountReceivables/AR";
import BarChartSGN from "../attributes/bar-chart/BarChartSGN";
import ListItemStrategicWrapper from "../listItem/listItemStrategicWrapper";
import RevenueDistributionStrategic from "../attributes/revenue-distribution/RevenueDistributionStrategic";

function Accordion(props) {
  const { type, title } = props
  const [setActive, setActiveState] = useState("");
  const [setHeight, setHeightState] = useState("0px");
  const [setRotate, setRotateState] = useState("accordion__icon rotate");
  const [region] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release- to fetch region specific data

  let regionName = region.toLowerCase() === "na" ? "North America" : "EMEA";

  const content = useRef(null);

  let accordionBody = "";

  let keys = []
  let values = []
  let pctGrowth = []


  function toggleAccordion() {//need to look into this function, as setActive is not updating the state properly and change variable names
    
    setActiveState(setActive === "" ? "active" : "");
    setHeightState( setActive === "active" ? "0px" : `${content.current.scrollHeight}px`);
    setRotateState( setActive === "active" ? "accordion__icon rotate" : "accordion__icon" );
    console.log("toggleAccordion--setActive", setActive.toString());
  }

  const onLoadOpenAccordion = () => {
    if (type === 'openOrder' && (props.open_backorder.open !== 0 ||
      props.open_backorder.back !== 0)) {
      toggleAccordion();
    }
    if (type === 'accountReceivable' && (props.open_dueAR.open !== 0 ||
      props.open_dueAR.due !== 0)) {
      toggleAccordion();
    }
  }

  useEffect(() => {
    onLoadOpenAccordion();
  }, []);


  switch (type) {
    case "customerSegment":
      accordionBody = (
        <RevenueDistribution id={1} {...props} name="customerSegments" />
      );
      break;
    case "productDivision":
      accordionBody = (
        <RevenueDistribution id={2} {...props} name="productDivisions" />
      )
      break;
    case "productDivisionStrategic":// we can remove this in next release after testing
      accordionBody = (
        <RevenueDistributionStrategic id={2} {...props} name="productDivisions" />
      )
      break;
    case "nsgn"://Added NSGN "included Accounts" accordion at customer level
      accordionBody = (
        <ListItemWrapper {...props} name="NSGNs" />
      )
      break;
    case "tier1"://Added Tier1 accounts accordion at Strategic Accts level
      accordionBody = (
        <ListItemStrategicWrapper {...props} name="NSGNs" />
      )
      break;
    case "OFM"://Added accordion Revenue Distribution by order fulfillment method
      accordionBody = (
        <RevenueDistribution id={3} {...props} name="OFM" />
      )
      break;
    case "businessUnits":
      accordionBody = (
        <RevenueDistribution id={4} {...props} name="businessUnits" />
      )
      break;
    case 'regions':
      accordionBody = (
        <RevenueDistribution id={5} {...props} name="regions" />
      )
      break;
    case "OMC"://Added accordion Revenue Distribution by order Mode Channel
      accordionBody = (
        <RevenueDistribution id={3} {...props} name="OMC" />
      )
      break;
    case "openOrder": //,...props.ofmBackOrder
      accordionBody = <Orders {...props} />
      //<Orders {...props.open_backorder} />
      break;
    case "accountReceivable":
      accordionBody = <AccountReceivables {...props.open_dueAR} />
      break;
    case "credit":
      accordionBody = <Credit {...props.credit} />
      break;
    case "covid":
      const skus = (props.skus) ? [...props.skus] : []
      keys = skus.map(element => element.name)
      values = skus.map(element => element.revenue)
      pctGrowth = skus.map(element => (((element.revenue - element.lastRevenue)
        / (element.revenue + element.lastRevenue)) * 100).toFixed(2))

      accordionBody = <React.Fragment>
        <Header y2axis={'Growth %'} />
        <BarChart
          id="covid"
          keys={keys}
          values={values}
          height={150}
          pctGrowth={pctGrowth}
          y2axis={'Growth'} />
        <Footer y1axis={'Revenue ($ in M)'} />
      </React.Fragment>
      break;
    case "customerRevenue":
      const customers = (props.customers) ? [...props.customers] : []
      //voiceRevenue = (props.voiceRevenue) ? props.voiceRevenue : 0
      keys = customers.map(element => element.name === undefined ? null : element.name)
      values = customers.map(element => element.revenue === undefined ? null : element.revenue)
      //total = customers.reduce((sum, element) => sum += element.revenue, 0)
      //Remove Contribution % from 5 Top Customers/SGNs by Revenue and Contribution
      //pctGrowth = customers.map(element => (Number((element.revenue / voiceRevenue) * 100)).toFixed(2))
      pctGrowth = [];
      accordionBody = <React.Fragment>
        {/*<Header y2axis={'Contribution %'} />*/}
        <div className={`barChartContainer`}>
          <BarChart
            id="customer"
            keys={keys}
            values={values}
            height={250}
            pctGrowth={pctGrowth}
            y2axis={'Contribution'} />
          <Footer y1axis={'Revenue ($ in M)'} />
        </div>
      </React.Fragment>
      break;
    case "sgns":
      const sgns = (props.sgns) ? [...props.sgns] : []
      //voiceRevenue = (props.voiceRevenue) ? props.voiceRevenue : 0;
      keys = sgns.map(element => {
        let sgnKey = `${element.id} - ${element.name}`
        return sgnKey
      })
      values = sgns.map(element => element.revenue)
      //total = sgns.reduce((sum, element) => sum += element.revenue, 0)
      //Remove Contribution % from 5 Top Customers/SGNs by Revenue and Contribution
      //pctGrowth = sgns.map(element => (Number((element.revenue / voiceRevenue) * 100)).toFixed(2))
      pctGrowth = []
      accordionBody = <React.Fragment>
        {/*<Header y2axis={'Contribution %'} />*/}
        <div className={`barChartContainer`}>
          <BarChartSGN
            id="sgns"
            keys={keys}
            values={values}
            height={250}
            pctGrowth={pctGrowth}
            y2axis={'Contribution'} />
          <Footer y1axis={'Revenue ($ in M)'} />
        </div>
      </React.Fragment>
      break;
    case "accounts":
      const accounts = (props.accounts) ? [...props.accounts] : []
      // voiceRevenue = (props.voiceRevenue) ? props.voiceRevenue : 0;
      keys = accounts.map(element => element.name === undefined ? null : element.name)
      values = accounts.map(element => element.revenue)
      // total = accounts.reduce((sum, element) => sum += element.revenue, 0)
      //Remove Contribution % from 5 Top Customers/SGNs by Revenue and Contribution
      //pctGrowth = sgns.map(element => (Number((element.revenue / voiceRevenue) * 100)).toFixed(2))
      pctGrowth = []
      accordionBody = <React.Fragment>
        {/*<Header y2axis={'Contribution %'} />*/}
        <div className={`barChartContainer`}>
          <BarChart
            id="accounts"
            keys={keys}
            values={values}
            height={250}
            pctGrowth={pctGrowth}
            y2axis={'Contribution'} />
          <Footer y1axis={'Revenue ($ in M)'} />
        </div>
      </React.Fragment>
      break;
    default:
      break;
  }
  const checkAccordionVisible = () => { //try with the short hand !props.open_backorder instead of undefined or null
    let flag = true;
    switch (type) {
      case 'productDivision':
      case 'regions':
      case 'customerSegment':
      case 'businessUnits':
        if (props.list === null || !props.list.length)
          flag = false;
        break;
      case 'openOrder':
        if (props.open_backorder === null || (props.open_backorder.open === undefined && props.open_backorder.back === undefined))
          flag = false;
        break;
      case 'sgns':
        if (props.sgns === null ||
          (props.sgns.length === 1 && props.sgns[0].code === ' ' && props.sgns[0].name === ' '))
          flag = false;
        break;
      case 'credit':
        if (props.credit === null ||
          (props.credit.total === undefined && props.credit.available === undefined))
          flag = false;
        break;
      case 'covid':
        if (props.skus === null || !props.skus.length)
          return false;
        break;
      case 'customerRevenue':
        if (props.customers === null || !props.customers.length)
          return false;
        break;
      default:
        break;
    }
    return flag;
  }


  return (<div>
    <div className={checkAccordionVisible() ? `accordion__section` : `accordion__section makeDisable`}>
      <div className='horizontalDivider'></div>
      <button className={`accordion ${setActive}`} onClick={toggleAccordion}>
        <p className="accordion__title">{title}</p>
        <Chevron className={`${setRotate}`} width={10} fill={"#777"} />
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="accordion__content"
      >
        {accordionBody}
        <div className="lsgLabel">{`Data scope LSG-E1 ${regionName}`}</div>
      </div>
    </div>
  </div>
  );
}

export default Accordion;
